import produce from 'immer';

import {
  SAVE_STARTED,
  SET_SETTINGS,
} from './actions';

const emptyState = {
  allowDeals: null,
  royaltyPercent: null,
  saving: false,
};

export default produce((state, action) => {
  switch (action.type) {
  case SAVE_STARTED:
    state.saving = true;
    break;
  case SET_SETTINGS:
    state.saving = false;
    state.allowDeals = action.allowDeals;
    state.royaltyPercent = action.royaltyPercent;
    break;
  }
}, emptyState);
